export const Languages = {
  PT_BR: 'pt-BR',
};
